"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Container = _interopRequireDefault(require("../Layout/Container"));

var _Hamburger = _interopRequireDefault(require("../Hamburger"));

var _NavigationScroll = _interopRequireDefault(require("../NavigationScroll"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];

  if (null != _i) {
    var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;

    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Header = function Header(_ref) {
  var logo = _ref.logo,
      menu = _ref.menu,
      subMenu = _ref.subMenu,
      forceHamburger = _ref.forceHamburger,
      withAnimation = _ref.withAnimation,
      customHamburger = _ref.customHamburger;

  var _useState = (0, _react.useState)({
    visible: false,
    reachedTop: true,
    scrolledPastNavHeight: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];

  var className = (0, _classnames.default)('Header', {
    'Header--default': !forceHamburger,
    'Header--force-hamburger': forceHamburger,
    'show-nav': active
  });

  if (forceHamburger) {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./style-force-hamburger.scss'));
    }).then(function () {// Do nothing.
    });
  } else {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./style-default.scss'));
    }).then(function () {// Do nothing.
    });
  }

  var onUpdateNavigationScroll = function onUpdateNavigationScroll(isVisible, hasReachedTop, scrolledPastNavHeight) {
    var shouldUpdate = state.visible !== isVisible || state.reachedTop !== hasReachedTop || state.scrolledPastNavHeight !== scrolledPastNavHeight;

    if (shouldUpdate) {
      setState({
        scrolledPastNavHeight: scrolledPastNavHeight,
        visible: isVisible,
        reachedTop: hasReachedTop
      });
    }
  };

  var headerComponent = /*#__PURE__*/_react.default.createElement("header", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "Header__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Header__logo"
  }, logo), menu && /*#__PURE__*/_react.default.createElement("div", {
    className: "Header__menu__wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Header__menu"
  }, menu), customHamburger ? /*#__PURE__*/_react.default.createElement("div", {
    className: "Header__hamburger"
  }, customHamburger) : /*#__PURE__*/_react.default.createElement("div", {
    className: "Header__hamburger"
  }, /*#__PURE__*/_react.default.createElement(_Hamburger.default, {
    onClick: function onClick() {
      return setActive(!active);
    }
  }))))), subMenu && /*#__PURE__*/_react.default.createElement("div", {
    className: "Header__subMenu"
  }, /*#__PURE__*/_react.default.createElement(_Container.default, null, subMenu)));

  if (withAnimation) {
    return /*#__PURE__*/_react.default.createElement(_NavigationScroll.default, {
      onUpdate: onUpdateNavigationScroll,
      hasBackground: true
    }, headerComponent);
  } else {
    return headerComponent;
  }
};

var _default = Header;
exports.default = _default;